import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import NConformidadePage from './nconformidade.page';
import WebapiCommon from '../../../../../app/common/util/webapi.common';
import * as commonActions from '@common/common.action';
import HistologiaApi from '../../histologia.api';
import IntlMessage from "../../../../../helpers/intlMessage";
import { getUsuarioLocalStorage } from '../../../../../localStorage.util';

class NConformidadeContainer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      nConformidadeId: null,
      impeditiva: false,
      exibirNaoConformidadeNoLaudo: false,
      exibidaNoTextoFinalLaudo: false,
      historicoNaoConf: [],
      usuarioLocal: getUsuarioLocalStorage()
    };

    this.getHistorico();
  }

  getHistorico () {
    this.props.commonActions.showFadeCarregando(true);
    if (this.props.item.etapa === 1) {
      WebapiCommon.getHistInconformidadesBlocos(this.props.item.id).then(
        result => {
          this.setState({ historicoNaoConf: result });
          this.props.commonActions.showFadeCarregando(false);
        }
      );
    } else if (this.props.item.etapa === 3) {
      WebapiCommon.getHistInconformidadesLaudoLamina(
        this.props.item.coluna,
        this.props.item.id
      ).then(res => {
        this.setState({ historicoNaoConf: res });
        this.props.commonActions.showFadeCarregando(false);
      });
    } else {
      WebapiCommon.getHistInconformidadesLamina(this.props.item.id).then(
        result => {
          this.setState({ historicoNaoConf: result });
          this.props.commonActions.showFadeCarregando(false);
        }
      );
    }
  }
  onChangeInconformidade (event) {
    this.setState({
      nConformidadeId: event.value,
      impeditiva: event.label.indexOf('Impeditiva') !== -1
    });
  }

  adicionarNaoConformidade () {
    
    if (!this.state.nConformidadeId) {
      this.props.commonActions.showAlerta(
        'erro',
        `${this.props.intl.formatMessage({ id: "dashboards.cytology.selectNonConformity" })}`,
        2000,
        '450px'
      );
      return
    }

    var request = null;
    this.props.commonActions.showFadeCarregando(true);
    if (this.props.item.etapa === 1) {
      request = HistologiaApi.registrarNaoConformidadeBloco(
        this.props.item.id,
        this.state.nConformidadeId,
        this.state.exibirNaoConformidadeNoLaudo,
        this.state.usuarioLocal.usuarioId,
        'TECNICA'
      );
    } else if (this.props.item.etapa === 3) {
      let param = {
        idLaudo: this.props.item.idLaudo,
        exameId: this.props.item.idExame,
        nConfirmidadeId: this.state.nConformidadeId,
        nomeEtapa: 'LAMINA_CITOLOGIA',
        idUsuario: this.state.usuarioLocal.usuarioId
      };

      if (this.props.item.coluna === 'laudo_lamina') {
        param.idLaudoLamina = this.props.item.id;
      }

      if (this.props.item.coluna === 'bloco_lamina') {
        param.idBlocoLamina = this.props.item.id;
      }

      request = WebapiCommon.adicionarHistInconformidades(param);
    } else {
      request = HistologiaApi.registrarNaoConformidadeLamina(
        this.props.item.id,
        this.state.nConformidadeId,
        this.state.exibirNaoConformidadeNoLaudo,
        this.state.usuarioLocal.usuarioId,
        'TECNICA'
      );
    }

    request.then(result => {
      this.props.commonActions.showFadeCarregando(false);
      this.props.commonActions.showAlerta(
        'sucesso',
        `${this.props.intl.formatMessage({ id: "dashboards.histology.nonconformitySuccessfullyAdded" })}`,
        5000
      );
      this.getHistorico();
      if (
        typeof this.props.callBackConclusaoInclusaoResolucaoNConformidade ===
        'function'
      ) {
        this.props.callBackConclusaoInclusaoResolucaoNConformidade();
      }
    });
  }

  getDateResolucao (date) {
    if (date) {
      var dt = new Date(date);
      return dt.toLocaleDateString() + ' às ' + dt.toLocaleTimeString() + 'hrs';
    } else {
      return null;
    }
  }

  exibirNaoConformidadeNoLaudoChangeValor () {
    this.setState(state => ({
      exibirNaoConformidadeNoLaudo: !state.exibirNaoConformidadeNoLaudo
    }));
  }

  atualizarExibicaoNaoConformidadeNoTextoFinalLaudo (idNConfoHist, exibir) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.atualizarSnImprimirNConformidadeNoLaudo(
      idNConfoHist,
      exibir
    ).then(() => {
      this.props.commonActions.showFadeCarregando(false);
      this.props.commonActions.showAlerta(
        'sucesso',
        `${this.props.intl.formatMessage({ id: "dashboards.histology.displayUpdatedSuccessfully" })}`,
        5000
      );
      this.getHistorico();
    });
  }

  setJustificativa (justificativa) {
    this.setState({
      justificativa: justificativa
    });
  }

  existeJustificativa () {
    if (
      this.state.justificativa &&
      this.state.justificativa !== null &&
      this.state.justificativa !== ''
    ) {
      return true;
    } else {
      return false;
    }
  }

  resolverNaoConformidade (id) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.resolverNaoConformidade(id, this.state.justificativa).then(
      () => {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'sucesso',
          `${this.props.intl.formatMessage({ id: "dashboards.histology.resolutionSavedSuccessfully" })}`,
          5000
        );
        this.getHistorico();
        if (
          typeof this.props.callBackConclusaoInclusaoResolucaoNConformidade ===
          'function'
        ) {
          this.props.callBackConclusaoInclusaoResolucaoNConformidade();
        }
      }
    );
  }

  render () {
    const altura = window.innerHeight - 255;
    return (
      <NConformidadePage
        intl={this.props.intl}
        open={this.props.open}
        toggle={this.props.toggle}
        item={this.props.item}
        altura={altura}
        naoconformidades={this.props.naoconformidades}
        historicoNaoConf={this.state.historicoNaoConf}
        getDateResolucao={this.getDateResolucao.bind(this)}
        setJustificativa={this.setJustificativa.bind(this)}
        existeJustificativa={this.existeJustificativa.bind(this)}
        onChangeInconformidade={this.onChangeInconformidade.bind(this)}
        resolverNaoConformidade={this.resolverNaoConformidade.bind(this)}
        adicionarNaoConformidade={this.adicionarNaoConformidade.bind(this)}
        exibirNaoConformidadeNoLaudoChangeValor={this.exibirNaoConformidadeNoLaudoChangeValor.bind(
          this
        )}
        atualizarExibicaoNaoConformidadeNoTextoFinalLaudo={this.atualizarExibicaoNaoConformidadeNoTextoFinalLaudo.bind(
          this
        )}
      ></NConformidadePage>
    );
  }
}

const mapStateToProps = state => {
  return {
    carregando: state.commonReducer.showCarregando,
    mensagem: state.commonReducer.mensagemAlerta,
    timeout: state.commonReducer.timeoutAlerta,
    tipoAlerta: state.commonReducer.tipoAlerta,
    idAlerta: state.commonReducer.idAlerta
  };
};
// export default NConformidadeContainer;
const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NConformidadeContainer);



// WEBPACK FOOTER //
// ./src/pages/histologia/common/modais/nconformidade/nconformidade.container.js